import { render, staticRenderFns } from "./CreateQuestionnaire.vue?vue&type=template&id=0b107ce0&scoped=true&"
import script from "./CreateQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./CreateQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./CreateQuestionnaire.vue?vue&type=style&index=0&id=0b107ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b107ce0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VProgressLinear,VTab,VTabs})
